export default '5.27.0';